/* eslint-disable no-param-reassign, no-plusplus, prefer-const */
const polyfills = () => {
  if (!Object.fromEntries) {
    Object.fromEntries = (iterable: any) => {
      return [...iterable].reduce((obj, [key, val]) => {
        obj[key] = val;
        return obj;
      }, {});
    };
  }
};

export default polyfills;
